// DATA
// button > id / isLast 필수
/*
{
  type: "button",
  classes: ["inputBtn02", "mt20"],
  id: "btn1",
  label: "시작하기",
  isLast: true,
},
*/
export const CHAT_DATA = {
  dataArr01: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "방탈출 안내사항을 확인해주세요.",
    },

    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: '고양이 탐정 : 추리살롱 양재<br/><span class="txtW700">잊혀진 기억</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">1.외부 유출 금지!</span><br/>해당 방탈출 문제는 저작권법에 의해 보호받고 있습니다. 방탈출 문제는 모두의 재미를 위해 외부 유출을 금지합니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">2.문의사항은 데스크</span><br/>방탈출과 관련한 문의사항은 데스크에 이야기 해주세요.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">3.제한시간 60분</span><br/>이 방탈출은 제한시간 60분 동안 즐길 수 있습니다. 중요한 단서는 메모하세요!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "시작하기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/tutorial",
    },
  ],
  dataArr02: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "방탈출 스토리를 확인해주세요.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: '당신은 사람들의 행복한 기억을 찾아주는 <span class="txtW700">추리살롱 양재</span>에서 첫 임무를 맡은 수습탐정입니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "오늘은 말하는 고양이탐정 ‘꼬네’와 함께 특별한 임무를 수행합니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "바로, 잊혀진 기억의 조각을 찾아 의뢰인의 기억과 이름을 되찾는 것.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">제한 시간은 30분</span><br/> 과연, 무사히 미션을 완수할 수 있을까요?',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">CODE 1</span> 카드를 확인하세요.',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "<CODE 1> 카드 확인",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  DATA3: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "고양이탐정 꼬네에게 알맞는 <br/>키워드를 검색하세요.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: "나는 미스터리 사건을 수사하는 고양이 탐정 꼬네다냥.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '네가 찾은 <span class="txtW700">추리 키워드</span>를 알려주면 나의 신비한 능력으로 ',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">키워드</span>에 해당하는<br/> 사람/장소/단서가 있는 곳으로 <span class="txtW700">이동</span>이 가능 하다냥.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '제한시간 30분 내에 사건을 해결하면 보상을 받을 수 있다냥!<br/>그럼 <span class="txtW700">추리 키워드</span>를 입력하라냥.',
    },
    {
      type: "scroll",
    },
  ],
  //sl7
  quiz01: [
    {
      type: "chatInfo_Talk1",
      marType: "mb17",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 1</span><br/>가로수길, 샤로수길 처럼 양재천 일대 상권을 부르는 거리 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 1&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer01: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 살롱in양재천",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "양재천길 로컬브랜드가 조화롭게 만나는 살롱 공간",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #1</span><br/>의뢰인은 종종 <span class="txtW700">살롱 in 양재천</span> 거리를 산책하며 마음을 다잡곤 했다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 2&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //md3
  quiz02: [
    {
      type: "chatInfo_Talk1",
      marType: "mb17",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 2</span><br/>조개 껍질을 틀로 삼아 빵을 만들어 냈다고 해서 유래된 이 디저트의 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 2&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer02: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 마들렌",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "작은 카스텔라의 일종으로 밀가루, 버터, 달걀,  우유 따위를 넣고 반죽하여 조개 모양으로 구운 프랑스 과자",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #2</span><br/>의뢰인은 오전 잔고 정산이 끝나면 가방 안에 있는 <span class="txtW700">마들렌</span> 한 개를 꺼내 먹곤 했다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: '<span class="txt44BAD1">[핵심 단서 #1 : 양]</span>',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 3&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //wc2
  quiz03: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 3</span><br/>마들렌으로 유명한 두 글자의 살롱 in 양재천의 상호명을 찾으시오.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 3&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk3",
      text: "단서 2 : B2D3+B5D3",
    },
    {
      type: "scroll",
    },
  ],
  answer03: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 우쿠",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "하와이어로 작은선물을 뜻합니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #3</span><br/>의뢰인이 마들렌을 사는 곳은 <span class="txtW700">우쿠</span>였다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 4&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //wi2
  quiz04: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "<span class=\"txt44BAD1\">CODE 4</span><br/>마들렌의 유래로 유명한 이 나라는 '미식과 향기의 나라'로 불립니다. 그렇다면 이 나라를 대표하는 주류로 가장 널리 알려진 것은 무엇일까요?",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 4&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk3",
      text: "단서 2 : E2B4C3A5",
    },
    {
      type: "scroll",
    },
  ],
  answer04: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 와인",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "프랑스는 세계적인 와인 생산국으로 잘 알려져 있습니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #4</span><br/>의뢰인은 <span class="txtW700">와인</span>은 마시지 못하지만, 색깔과 향을 좋아했다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 5&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //cl4
  quiz05: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 5</span><br/>양재천을 "와인"의 거리로 만든 2001년 오픈 한 전통의 와인샵은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 5&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk3",
      text: "단서 2 : 4123",
    },
    {
      type: "scroll",
    },
  ],
  answer05: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 크로스비",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "프랑스 와인 뿐 아니라 와인 수입전문업체입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #5</span><br/>의뢰인은 가끔 와인 수입 전문 업체 <span class="txtW700">크로스비</span>에서 와인을 구경했다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 6&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //sb4
  quiz06: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 6</span><br/>크로스비 건너편에서 의뢰인은 ‘이 무대’ 위에서 열리는 작은 클래식 공연을 보러갔다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 1 : &lt;CODE 6&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 2 : 호숫가나 강변 따위의 물가에 공연이나 관람을 할 수 있도록 만들어 놓은 무대.",
    },
    {
      type: "scroll",
    },
  ],
  answer06: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 수변무대",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "양재천에서 가장 유동인구가 많은 수변무대이며 각종 행사가 연중 이어집니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #6</span><br/>의뢰인은 이전에 양재천 <span class="txtW700">수변무대</span>에 열리는 작은 클래식 공연을 보러 갔다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: '<span class="txt44BAD1">[핵심 단서 #2 : 르]</span>',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 7&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //mj2
  quiz07: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 7</span><br/>의뢰인의 친구는 그의 옆에서 ■■를 쓰고 클래식 공연을 함께 보았다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 7&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer07: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 모자",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "머리에 쓰는 물건의 하나.<Br/>예의를 차리거나 추위, 더위, 먼지 따위를 막기 위한 것이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #7</span><br/>의뢰인의 친구는 그의 옆에서 <span class="txtW700">모자</span>를 눌러 쓰고 클래식 공연을 함께 보았다. 친구는 같은 클래식 청음회 멤버이다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 8&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //gb11
  quiz08: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk3",
      text: '<span class="txt44BAD1">CODE 8</span><br/>의뢰인의 올 해 목표 :<br/>1. 다이어트 2. 영어',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 8&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer08: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : god bless you",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "누군가에게 행운을 바랄 때 사용 하는 숙어",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #8</span><br/><span class="txtW700">수변무대</span>를 구경하다가 의뢰인은 감기에 걸렸고, 친구는 혼자 사는 의뢰인을 챙겨주었다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 9&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //bl3
  quiz09: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 9</span><br/>살롱 in 양재천, 양재 수제 모자로 유명한 이 상점의 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 9&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 2 : 6-23-4 / 4-25 / <br/>7-20-8",
    },
    {
      type: "scroll",
    },
  ],
  answer09: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 블레숑",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "블레숑은 로컬 크리에이터이자 햇메이커 손종우님이 운영하시는 수제 모자 제작점입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #9</span><br/>감사의 의미로 의뢰인은 친구에게 며칠 뒤 <span class="txtW700">블레숑</span> 매장에서 모자를 사서 주었다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 10&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //ee5
  quiz10: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 10</span><br/>살롱 in 양재천의 와인 바인 이곳의 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 10&gt; 카드를 확인하세요.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "단서 2 : A5D4A5",
    },
    {
      type: "scroll",
    },
  ],
  answer10: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : ete 에떼",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "ete 에떼는 살롱 in 양재천의 와인 바이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #10</span><br/>의뢰인은 친구와 <span class="txtW700">에떼</span> 와인바에 자주 갔다. 술은 먹지 않았지만 레드와인의 빨간색이 좋았다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: '<span class="txt44BAD1">[핵심 단서 #3 : 재]</span>',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 11&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //gm5
  quiz11: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 11</span><br/>살롱 in 양재천 중심에 있는 초록색 설치물 이름의 영문 글자 개수는?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 11&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer11: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 12",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "그린몬스터(green monster)는 양재살롱관에서 발급한 양재프랑을 넣으면 상권 내에서 사용 할 수 있는 쿠폰이나 선물 쿠폰이 나오는 설치물이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #11</span><br/>의뢰인은 <span class="txtW700">그린 몬스터</span> 앞을 지날 때마다 친구가 생각나서 싱긋 웃곤 했다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 12&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //dk3
  quiz12: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 12</span><br/>맛있는 양재천 맛집 ■■돈까스',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 12&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer12: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 한양",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "한양 돈까스는 살롱 in 양재천 노포로, 치킨 맛집이기도 합니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #12</span><br/>의뢰인 양서초는 점심이면 가끔 친구를 불러 <span class="txtW700">한양 돈까스</span>에서 돈까스를 먹었다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 13&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //bf8
  quiz13: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 13</span><br/>살롱 in 양재천 꽃집 중 하나로 부부가 운영하는 이 꽃집의 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 13&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer13: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 봄이옵니다플라워",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "봄이옵니다플라워는 살롱 in 양재천을 사랑하여 10년째 자리잡고 있는 로컬 대표 꽃집입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #13</span><br/>의뢰인 양서초는 친구의 승진 소식을 듣고 모임에서 만나면 줄 생각으로 <span class="txtW700"><봄이 옵니다. 플라워></span>에서 노랑 호접란을 사갔다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: '<span class="txt44BAD1">[핵심 단서 #4 : 옹]</span>',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 14&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //yj4
  quiz14: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 14</span><br/>의뢰인의 친구이자 양재살롱관의 호스트, 로컬 큐레이터인 이 사자의 이름은?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 14&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer14: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 양재르옹",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "양재살롱관의 호스트이자, 로컬 문화 큐레이터입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">기억의 조각 #14</span><br/><span class="txtW700">양재르옹</span>은 의뢰인 양서초가 기억을 잃기 전 만나기로 했던 친한 친구이다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 15&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //cl3
  quiz15: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 15</span><br/>1. 양재르옹의 모자에 새겨진 마크는 무엇일까?<br/>2. 의뢰인의 이름<br/><br/>정답 : 1+2 = 한글 글자 개수',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 15&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer15: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 8",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "네잎클로버(5)+양서초(3) = 8<br/>양재살롱관을 방문하는 모든 분에게 행운이 있기를 바라는 마음을 담은 이미지입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "좋아! 이 기세로 다음 문제를 해결해 보자냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "<span class=\"txt44BAD1\"><의뢰인의 정보 확인하기></span><br/>&nbsp;<span class='dotIn5'></span> 의뢰인의 이름은 양서초<Br/>&nbsp;<span class='dotIn5'></span> 30대 초반 살롱인 양재천 <Br/><span class='dotIn3'></span>&nbsp;근처 은행원이다.<Br/>&nbsp;<span class='dotIn5'></span> 양재르옹은 양재살롱에서<Br/> <span class='dotIn3'></span>&nbsp;같이 클래식을 듣는 청음회<Br/> <span class='dotIn3'></span>&nbsp;멤버이자,<Br/>&nbsp;<span class='dotIn5'></span> 의뢰인이 힘들 때 마음을 털<Br/><span class='dotIn3'></span>&nbsp;어놓는 친한 친구이다.<Br/>&nbsp;<span class='dotIn5'></span> 그는 기억을 잃기 전 양재르<Br/><span class='dotIn3'></span>&nbsp;옹과 함께 살롱 문화의 클래<Br/><span class='dotIn3'></span>&nbsp;식 작품인<Br/>&nbsp;<span class='dotIn5'></span> 쇼팽 녹턴 op.9 no.2 야상<Br/><span class='dotIn3'></span>&nbsp;곡을 듣기로 했다.",
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">&lt;CODE 16&gt;</span> 카드의 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥. 아래 <span class="txtW700">돌아가기</span>를 누르면 <span class="txtW700">키워드 입력창</span>으로 돌아갈 수 있다냥!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //양서초
  quiz16: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "의문의 방에서 시스템 메시지가 보인다.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txt44BAD1">CODE 16</span><br/>의뢰인은 오늘 양재르옹과 청음회 동호회에서<Br/>쇼팽 녹턴 op.[A] no.[B] 야상곡을 들으려 했다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "단서 : &lt;CODE 16&gt; 카드를 확인하세요.",
    },
    {
      type: "scroll",
    },
  ],
  answer16: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk3",
      text: "정답이다냥~!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "정답 : 7",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "의뢰인은 오늘 양재르옹과 청음회 동호회에서 쇼팽 녹턴 op.9 no.2 야상곡을 듣기로 했다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "미션을 완수하고 모든 방 탈출을 마쳤다냥!",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk3",
      text: "방탈출 기록을 확인하라냥!",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "돌아가기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
};
